import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { alpha } from '@mui/material/styles';
import { useT } from '../i18n';

interface LoadingBackdropProps {
  open: boolean;
}

/** Capa de «Cargando…» sobre la pantalla mientras se consulta o se guarda; colores del tema en claro y oscuro. */
const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({ open }) => {
  const t = useT();
  return (
    <Backdrop
      open={open}
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        bgcolor: alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.6 : 0.55),
      })}
    >
      <CircularProgress color="primary" aria-label={t('common.loading')} />
    </Backdrop>
  );
};

export default LoadingBackdrop;
